import styles from "./FunAnimation.module.less";
import CommonNavBar from "views/components/CommonNavBar";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect, useCallback } from "react";
import { getCartoonVideoList } from "api/picture";
import { Toast } from "react-vant";
import useScrollLoad from "utils/useScrollLoad";
import BottomText from "views/picture/home/bottom-text/BottomText";
import DSBridge from "dsbridge";
import { debounce } from "lodash";
import CommonModal from "views/components/CommonModal";
import { navigateToSignIn } from "utils/tokenTools";

const FunAnimation = () => {
  const navigate = useNavigate();
  const [isShowUnread, setIsShowUnread] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [lockShow, setLockShow] = useState(false);
  const LoadingRef = useRef(null);

  const handleReadCallback = (list) => {
    try {
      list = JSON.parse(list);
      if (!Array.isArray(list)) {
        return;
      }
      const idSet = new Set(list.map((item) => item));

      setVideoList((prev) => {
        return prev.map((item) => {
          if (idSet.has(item.video_id)) {
            return {
              ...item,
              watching_status: {
                ...(item.watching_status || {}),
                is_started: true,
              },
            };
          }
          return item;
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickVideo = debounce((item) => {
    if (!localStorage.getItem("access_token")) {
      navigateToSignIn("#/login/logon");
      return;
    }
    if (item.is_lock === 1) {
      setLockShow(item.wechat_link);
      return;
    }
    if (DSBridge.hasNativeMethod("book.mediaPlayer")) {
      DSBridge.call(
        "book.mediaPlayer",
        {
          videoId: item.video_id,
          token: localStorage.getItem("access_token"),
          type: "interest",
          refreshToken: localStorage.getItem("refresh_token"),
          callback: "onVideoStatusChange",
        },
        (back) => {
          console.log(back);
        }
      );
    }
  }, 200);

  const getVideoList = async () => {
    setIsLoading(true);
    try {
      const videoRes = await getCartoonVideoList({
        page: 1,
        limit: 24,
        unread_only: isShowUnread ? 1 : 0,
      });

      if (videoRes.code === 200) {
        const newVideos = videoRes.data.videos || videoRes.data.list || [];
        setVideoList(newVideos);
        setCurrentPage(2);
        setHasMore(newVideos.length >= 24);
      }
    } catch (error) {
      console.log(error);
      Toast.fail("获取视频列表失败，请返回重试");
    } finally {
      setIsLoading(false);
    }
  };

  const loadMoreVideos = useCallback(async () => {
    if (isLoading || !hasMore) return;
    setIsLoading(true);
    try {
      const videoRes = await getCartoonVideoList({
        page: currentPage,
        limit: 24,
        unread_only: isShowUnread ? 1 : 0,
      });

      if (videoRes.code === 200) {
        const newVideos = videoRes.data.videos;
        if (newVideos.length > 0) {
          setVideoList((prev) => [...prev, ...newVideos]);
          setCurrentPage((prev) => prev + 1);
          if (newVideos.length < 24) setHasMore(false);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      Toast.fail("加载失败，请重试");
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, isLoading, hasMore, isShowUnread]);

  const containerRef = useScrollLoad(loadMoreVideos, 100);

  useEffect(() => {
    setCurrentPage(1);
    setHasMore(true);
    setVideoList([]);
    getVideoList();
  }, [isShowUnread]);

  const handleUnreadToggle = () => {
    setIsShowUnread(!isShowUnread);
  };

  const handleClickWx = () => {
    if (!lockShow) {
      return Toast.info("暂无跳转链接，请稍后重试");
    }
    try {
      if (DSBridge.hasNativeMethod("route.navigation")) {
        DSBridge.call(
          "route.navigation",
          {
            route: "miniProgram",
            mid: "gh_ce82ce6b1629",
            path: lockShow,
          },
          (back) => {
            console.log(back);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
    setLockShow(false);
  };

  useEffect(() => {
    DSBridge.register("onVideoStatusChange", (data) => {
      handleReadCallback(data);
    });

    return () => {
      if (LoadingRef.current?.clear) {
        LoadingRef.current?.clear();
        LoadingRef.current = null;
      }
    };
  }, []);

  return (
    <div className={styles["fun-animation-container"]}>
      <CommonNavBar
        backgroundColor="transparent"
        onClickBack={() => navigate(-1)}
      />
      <div className={styles["header-title"]}>趣味动画</div>
      <div className={styles["drop-box"]}>
        <div className={styles["drop-box-right"]} onClick={handleUnreadToggle}>
          <div className={styles["drop-box-right-circle"]}>
            {isShowUnread && <div className={styles["circle-active"]}></div>}
          </div>
          <div className={styles["drop-box-right-text"]}>只展示未看</div>
        </div>
      </div>

      <div className={styles["books-box"]} ref={containerRef}>
        {videoList.map((item, index) => (
          <div
            className={styles["interest-box"]}
            key={`${index}-interest`}
            onClick={() => handleClickVideo(item)}
          >
            <div className={styles["interest-box-content"]}>
              <div className={styles["content-video"]}>
                <img
                  src={item.cover_url}
                  className={styles["content-video-img"]}
                />
                {item.is_lock === 1 && (
                  <div className={styles["content-video-lock"]}>
                    <img
                      className={styles["lock-img"]}
                      src={require("@/images/picture/e-book/lock.png")}
                    />
                  </div>
                )}
              </div>
              <div className={styles["content-text"]}>{item.video_name}</div>
            </div>
            {item.watching_status?.is_started && (
              <img
                className={styles["interest-box-icon"]}
                src={require(
                  `@/images/picture/fun-animation/is-read-phone.png`
                )}
              />
            )}
          </div>
        ))}

        <BottomText
          isLoading={isLoading}
          dataList={videoList}
          hasMore={hasMore}
        />
      </div>
      <CommonModal isOpen={lockShow}>
        <div className={styles["pop-container--lock"]}>
          <img
            onClick={() => setLockShow(false)}
            className={styles["lock-close"]}
            src={require("@/images/picture/e-book/lock-close.png")}
          />
          <img
            onClick={() => handleClickWx()}
            className={styles["lock-button"]}
            src={require("@/images/picture/e-book/lock-button.png")}
          />
        </div>
      </CommonModal>
    </div>
  );
};

export default FunAnimation;
